export const FACILITY_OVERVIEW_FORMS = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "contactMechTypeId", "contactMechId", "attName", "address1", "address2", "city", "stateProvinceGeoId", "postalCode", "countryGeoId", "fromDate", "thruDate", "removeLink", "updateLink" ]
        } ],
        "columns" : [ {
            "name" : "postalAddress",
            "title" : "Postal Address"
        }/* , {
            "name" : "attName",
            "title" : "attnName"
        }, {
            "name" : "address1",
            "title" : "address1"
        }, {
            "name" : "address2",
            "title" : "address2"
        }, {
            "name" : "city",
            "title" : "city"
        }, {
            "name" : "stateProvinceGeoId",
            "title" : "stateProvinceGeoId"
        }, {
            "name" : "postalCode",
            "title" : "postalCode"
        }, {
            "name" : "countryGeoId",
            "title" : "countryGeoId"
        }, {
            "name" : "fromDate",
            "title" : "fromDate"
        }, {
            "name" : "thruDate",
            "title" : ""
        }, {
            "name" : "removeLink",
            "title" : ""
        }, {
            "name" : "updateLink",
            "title" : ""
        } */ ],
        "formName" : "ViewFacilityPostalAddress",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "facilityId",
            "action" : "",
            "id" : "ViewFacilityPostalAddress_facilityId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "WebStoreWarehouse"
        }, {
            "conditionGroup" : "",
            "name" : "contactMechTypeId",
            "action" : "",
            "id" : "ViewFacilityPostalAddress_contactMechTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "ViewFacilityPostalAddress_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "attName",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityPostalAddress_attName",
            "title" : "attnName",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address1",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityPostalAddress_address1",
            "title" : "address1",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address2",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityPostalAddress_address2",
            "title" : "address2",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "city",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityPostalAddress_city",
            "title" : "city",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "stateProvinceGeoId",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityPostalAddress_stateProvinceGeoId",
            "title" : "stateProvinceGeoId",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "postalCode",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityPostalAddress_postalCode",
            "title" : "postalCode",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "countryGeoId",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityPostalAddress_countryGeoId",
            "title" : "countryGeoId",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityPostalAddress_fromDate",
            "title" : "fromDate",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "id" : "ViewFacilityPostalAddress_thruDate",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "removeLink",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "id" : "ViewFacilityPostalAddress_removeLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteContactMech"
        }, {
            "image" : "",
            "width" : "",
            "name" : "updateLink",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "id" : "ViewFacilityPostalAddress_updateLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "editcontactmech"
        },{
            name:"postalAddress",
            title:"Postal Address",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "attName",
                    "title" : "Attention"                    
                },
                {
                    "name" : "address1",
                    "title" : "Address 1"                    
                },
                {
                    "name" : "address2",
                    "title" : "Address 2"                    
                },
                {
                    "name" : "city",
                    "title" : "City"                    
                },
                {
                    "name" : "stateProvinceGeoId",
                    "title" : "Province/State"                    
                },
                {
                    "name" : "countryGeoId",
                    "title" : "Country"                    
                },
                {
                    "name" : "fromDate",
                    "title" : "From Date"                    
                },
                {
                    "name" : "thruDate",
                    "title" : "Thru Date"                    
                },
            ]
        } ],
        "target" : ""

    },
    {
    "fieldSets" : [ {
        "fieldSetName" : "Default",
        "fields" : [ "contactMechTypeId", "contactMechId", "contactMechPurposes", "areaCode", "countryCode", "contactNumber", "fromDate", "thruDate", "removeLink", "updateLink" ]
    } ],
    "columns" : [ /* {
        "name" : "contactMechPurposes",
        "title" : "Purpose/s"
    }, {
        "name" : "areaCode",
        "title" : "Area Code"
    }, {
        "name" : "countryCode",
        "title" : "Country Code"
    }, {
        "name" : "contactNumber",
        "title" : "Contact Number"
    }, {
        "name" : "fromDate",
        "title" : "From Date"
    }, {
        "name" : "thruDate",
        "title" : "Thru Date"
    }, {
        "name" : "removeLink",
        "title" : ""
    }, {
        "name" : "updateLink",
        "title" : ""
    } */ ],
    "formName" : "ViewFacilityTelecom",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
    "type" : "list",
    "fields" : [ {
        name:"telecomNumbers",
        title: "Contact Numbers",
        type:"COMPOSITE",
        innerFields:[
            {
                "name" : "contactMechPurposes",
                "title" : "Purpose/s"
            }, {
                "name" : "areaCode",
                "title" : "Area Code"
            }, {
                "name" : "countryCode",
                "title" : "Country Code"
            }, {
                "name" : "contactNumber",
                "title" : "Contact Number"
            }, {
                "name" : "fromDate",
                "title" : "From Date"
            }
        ]
    }, {
        "conditionGroup" : "",
        "name" : "facilityId",
        "action" : "",
        "id" : "ViewFacilityTelecom_facilityId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : "WebStoreWarehouse"
    }, {
        "conditionGroup" : "",
        "name" : "contactMechTypeId",
        "action" : "",
        "id" : "ViewFacilityTelecom_contactMechTypeId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
    }, {
        "conditionGroup" : "",
        "name" : "contactMechId",
        "action" : "",
        "id" : "ViewFacilityTelecom_contactMechId",
        "type" : "HIDDEN",
        "event" : "",
        "value" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "contactMechPurposes",
        "description" : "",
        "style" : "",
        "id" : "ViewFacilityTelecom_contactMechPurposes",
        "title" : "contactMechPurposeTypeId",
        "type" : "HIDDEN",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "areaCode",
        "description" : "",
        "style" : "",
        "id" : "ViewFacilityTelecom_areaCode",
        "title" : "areaCode",
        "type" : "HIDDEN",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "countryCode",
        "description" : "",
        "style" : "",
        "id" : "ViewFacilityTelecom_countryCode",
        "title" : "countryCode",
        "type" : "HIDDEN",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "contactNumber",
        "description" : "",
        "style" : "",
        "id" : "ViewFacilityTelecom_contactNumber",
        "title" : "contactNumber",
        "type" : "HIDDEN",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "fromDate",
        "description" : "",
        "style" : "",
        "id" : "ViewFacilityTelecom_fromDate",
        "title" : "fromDate",
        "type" : "HIDDEN",
        "imageLocation" : ""
    }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "thruDate",
        "description" : "",
        "style" : "",
        "id" : "ViewFacilityTelecom_thruDate",
        "title" : "thruDate",
        "type" : "HIDDEN",
        "imageLocation" : ""
    }, {
        "image" : "",
        "width" : "",
        "name" : "removeLink",
        "alternate" : "",
        "description" : "",
        "parameterList" : [ {
        "name" : "facilityId"
        }, {
        "name" : "contactMechId"
        } ],
        "id" : "ViewFacilityTelecom_removeLink",
        "imageTitle" : "",
        "parameterMap" : {
        "facilityId" : "WebStoreWarehouse"
        },
        "height" : "",
        "target" : "deleteContactMech"
    }, {
        "image" : "",
        "width" : "",
        "name" : "updateLink",
        "alternate" : "",
        "description" : "",
        "parameterList" : [ {
        "name" : "facilityId"
        }, {
        "name" : "contactMechId"
        } ],
        "id" : "ViewFacilityTelecom_updateLink",
        "imageTitle" : "",
        "parameterMap" : {
        "facilityId" : "WebStoreWarehouse"
        },
        "height" : "",
        "target" : "editcontactmech"
    } ],
    "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "infoString", "contactMechPurposes" ]
        } ],
        "columns" : [ /* {
            "name" : "infoString",
            "title" : "Email Address"
        }, {
            "name" : "contactMechPurposes",
            "title" : "contactMechPurposeTypeId"
        } */ ],
        "formName" : "ViewFacilityEmail",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"summary",
            title:"Details",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "infoString",
                    "title" : "Email Address"
                }, {
                    "name" : "contactMechPurposes",
                    "title" : "contactMechPurposeTypeId"
                }
            ]
        }, {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "ViewFacilityEmail_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "infoString",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityEmail_infoString",
            "title" : "Email Address",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechPurposes",
            "description" : "",
            "style" : "",
            "id" : "ViewFacilityEmail_contactMechPurposes",
            "title" : "contactMechPurposeTypeId",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "roleTypeId", "fromDate", "thruDate", "updateButton", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "partyId",
            "title" : "Party ID"
        }, {
            "name" : "roleTypeId",
            "title" : "Role Type ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Thru Date"
        }, {
            "name" : "updateButton",
            "title" : "Update"
        }, {
            "name" : "deleteLink",
            "title" : "Delete"
        } ],
        "formName" : "EditFacilityParties",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "facilityId",
            "action" : "",
            "id" : "EditFacilityParties_facilityId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "WebStoreWarehouse"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "EditFacilityParties_partyId",
            "title" : "Party ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "roleTypeId",
            "description" : "",
            "style" : "",
            "id" : "EditFacilityParties_roleTypeId",
            "title" : "Role Type ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "EditFacilityParties_fromDate",
            "title" : "CommonFromDate",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "CommonThruDate",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-18%2003:28:56.416",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditFacilityParties",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditFacilityParties_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "CommonFormatDateTime",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "CommonViewCalendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditFacilityParties",
            "tabindex" : "",
            "name" : "updateButton",
            "className" : "buttontext",
            "id" : "EditFacilityParties_updateButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "CommonDelete",
            "title" : "CommonDelete",
            "type" : "HIDDEN",
            "target" : "removePartyFromFacility",
            "name" : "deleteLink",
            "width" : "",
            "parameterList" : [ {
            "name" : "facilityId"
            }, {
            "name" : "partyId"
            }, {
            "name" : "roleTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "style" : "",
            "id" : "EditFacilityParties_deleteLink",
            "imageTitle" : "",
            "parameterMap" : {
            "facilityId" : "WebStoreWarehouse"
            },
            "height" : ""
        } ],
        "target" : "updateFacilityParty"
    }
]